var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYellowPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 14 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8B816",
  d: "M10.325 4.645c-.51 0-1.023-.026-1.53.009-.365.026-.502-.102-.547-.455q-.167-1.32-.385-2.637C7.694.537 7.255.022 6.581.001c-.695-.022-1.193.486-1.358 1.546-.15.972-.221 1.945-.29 2.93-.024.345-.121.487-.479.545-.822.122-1.637.288-2.452.444q-.251.06-.486.17C1.02 5.847.6 6.151.644 6.757c.042.606.517.851 1.05.934.974.153 1.947.297 2.92.399.365.038.521.146.56.53a21 21 0 0 0 .319 2.068c.179.867.656 1.31 1.33 1.311.673.001 1.17-.437 1.344-1.299a13.4 13.4 0 0 0 .25-2.077c.018-.437.121-.616.588-.679a47 47 0 0 0 3.571-.623c.94-.2 1.407-.709 1.386-1.337-.024-.682-.572-1.178-1.547-1.3-.692-.088-1.394-.082-2.092-.122z"
})));
export default SvgYellowPlus;